<template>
  <widget>
    <widget-header @close="$emit('close')">
      Edit Nameserver Info
    </widget-header>
    <widget-body>
      <form @submit.prevent="update" ref="form" class="x-form">
        <YInput v-model="editPrefix" label="Prefix"></YInput>
      </form>
    </widget-body>
    <widget-footer class="bg-gray-100 py-2 px-4 text-right">
      <y-button
        class="btn btn-blue"
        :is-loading="isSubmitting"
        @click="updateRelation"
        @keydown.enter="updateRelation"
        >Save Changes</y-button
      >
    </widget-footer>
    <ValidationErrors
      v-if="validationErrors"
      :errors="validationErrors"
    ></ValidationErrors>
  </widget>
</template>

<script>
import ValidationErrorsMixin from '@/mixins/ValidationErrorsMixin'
import UPDATE_DNS_MUTATION from '@/graphql/DomainNameserver/UpdateDnsNameserverMutation.gql'
import gql from 'graphql-tag'
export default {
  mixins: [ValidationErrorsMixin],
  props: {
    id: {
      type: Number,
      required: true
    },
    domainId: {
      type: String,
      required: true
    },
    prefix: {
      type: String,
      required: true
    },
    server: {
      type: Object,
      required: true
    }
  },
  components: {},
  apollo: {
    servers: {
      query: gql`
        query ydnsServers($filters: YdnsServerFilterInput) {
          servers: ydnsServers(filters: $filters) {
            id
            hostname
            serverIp
          }
        }
      `,
      variables() {
        return {
          filters: {
            type: {
              value: ['nameserver']
            }
          }
        }
      }
    }
  },
  data() {
    return {
      editId: this.id,
      editPrefix: this.prefix,
      isSubmitting: false,
      colSize: 'col-xl-3 col-lg-6',
      colSize2: 'col-xl-6 col-lg-12'
    }
  },
  watch: {},
  computed: {},
  methods: {
    updateRelation() {
      this.isSubmitting = true
      let input = {
        id: this.editId,
        domainId: this.domainId,
        domainPrefix: this.editPrefix
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_DNS_MUTATION,
          variables: {
            input: input
          }
        })
        .then(() => {
          this.isSubmitting = false
          this.$events.emit('refreshDnsDomains', true)
          this.$emit('close')
        })
        .catch(error => {
          console.log(error)
          this.isSubmitting = false
        })
    }
  },

  mounted() {},
  updated() {}
}
</script>
